import { sanitize } from 'isomorphic-dompurify';
import React, { ReactElement, useId } from 'react';
import Collapsible from 'react-collapsible';

import cn from './style.module.sass';
type CollapseListItemProps = {
    title: string;
    content: () => ReactElement;
    icon?: string;
};

type TriggerItemProps = {
    title: string;
    icon?: string;
};

function TriggerItem({ title, icon }: TriggerItemProps) {
    return (
        <div className={cn.triggerItem}>
            <div className={cn['triggerItem__left']}>
                {icon && (
                    <div className={cn['triggerItem__img']}>
                        <img src={icon} alt={icon} />
                    </div>
                )}
                <div
                    dangerouslySetInnerHTML={{ __html: sanitize(title) }}
                    className={cn['triggerItem__title']}
                />
            </div>
            <div className={cn['triggerItem__right']}>
                <div className={cn['triggerItem__arrow']}></div>
            </div>
        </div>
    );
}

export default function CollapseListItem({ title, content, icon }: CollapseListItemProps) {
    const id = useId();
    return (
        <Collapsible
            openedClassName={cn['collapseListItem--active']}
            classParentString={cn['collapseListItem']}
            triggerTagName={'div'}
            triggerElementProps={{ id }}
            contentElementId={id}
            contentInnerClassName={
                icon ? cn['collapseListItem__inner-solution'] : cn['collapseListItem__inner']
            }
            trigger={
                <div>
                    <TriggerItem title={title} icon={icon} />
                </div>
            }
        >
            {content()}
        </Collapsible>
    );
}
